export const testIds = {
  qualityScoreHelperScore: 'quality-score-helper-score',
  qualityScoreCheckMetadata: 'quality-score-check-metadata',
  qualityScoreCheckResults: 'quality-score-check-results',
  qualityScoreIndicator: 'quality-score-indicator',
};

export const qualityScoreHelperDetailsTitle = 'Quality Score Helper Details';
